import React, { createContext, useContext, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { translations } from "./i18n";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import Legal from "./pages/Legal";
import Properties from "./pages/Properties";
import PropertyDetail from "./pages/PropertyDetail";
import MemberAuth from "./pages/MemberAuth";
import MemberArea from "./pages/MemberArea";
import MemberDetail from "./pages/MemberDetail";
import ResetPassword from "./pages/ResetPassword";
import "./App.css";

const LanguageContext = createContext(null);
export const useLang = () => useContext(LanguageContext);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("flen-lang") || "fr");
  const t = translations[lang] || translations.fr;

  useEffect(() => {
    localStorage.setItem("flen-lang", lang);
    document.documentElement.lang = lang;
    document.title = t.meta.title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", t.meta.description);
  }, [lang, t]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export default function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/objekte" element={<Properties />} />
          <Route path="/objekte/verkauft" element={<Properties soldOnly />} />
          <Route path="/objekte/:id" element={<PropertyDetail />} />
          <Route path="/rentals" element={<Properties rental />} />
          <Route path="/rentals/:id" element={<PropertyDetail rental />} />
          <Route path="/espace" element={<MemberAuth />} />
          <Route path="/espace/objets" element={<MemberArea />} />
          <Route path="/espace/objets/:id" element={<MemberDetail />} />
          <Route path="/espace/reset-password/:token" element={<ResetPassword />} />
          <Route path="/mentions-legales" element={<Legal type="mentions" />} />
          <Route path="/politique-de-confidentialite" element={<Legal type="privacy" />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}
